import { Tag } from '@chakra-ui/react';
import styled, { css } from 'styled-components';
import SectionBox from '@/components/SectionBox';
import TransparentButton from '@/trio-ui/TransparentButton';

export const EmailInput = styled.div`
  margin-right: 6px;
  width: 100%;
  max-width: 230px;
`;

export const CustomTransparentButton = styled(TransparentButton)`
  margin: 24px 0;
`;

export const CustomSectionBox = styled(SectionBox)`
  font-size: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
  line-height: 18px;
  font-weight: 600;
`;

const defaultTextStyle = css`
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-80']};
  line-height: 21px;
  font-weight: 400;
`;

export const SendTo = styled.p`
  ${defaultTextStyle};
  margin-right: 6px;
`;

export const CandidateName = styled.p`
  ${defaultTextStyle};
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const CandidateEmail = styled.p`
  ${defaultTextStyle};
  color: ${(props) => props.theme.colors['primary-60']};
  margin-right: 6px;
  display: flex;
  align-items: center;
`;

export const Footer = styled.div`
  display: flex;
  margin-top: 24px;
  align-items: center;
  justify-content: center;
  button {
    width: 100%;
    max-width: 186px;
    justify-content: center;
  }
`;

export const CandidateDetails = styled.div`
  margin-bottom: 24px;
`;

export const InterviewInfo = styled.div<{ withBorder?: boolean }>`
  width: 50%;
  display: flex;
  align-items: start;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 24px;
  &:last-of-type {
    padding-left: ${(props) => (props.withBorder ? '32px' : '2px')};
    border-left: ${(props) => (props.withBorder ? '1px solid #ebebeb' : 'initial')};
  }
`;

export const LinkBox = styled.div`
  display: flex;
  align-items: center;
`;

export const ChallengeName = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['primary-90']};
  margin-right: 6px;
`;

export const InterviewLink = styled.a`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${(props) => props.theme.colors['primary-60']};
  display: flex;
  align-items: center;
  svg {
    margin-right: 5px;
  }
`;

export const ChallengeTag = styled(Tag)<{
  $isFirst?: boolean;
  $technologyType?: string;
}>`
  margin-left: ${(props) => (props.$isFirst ? '0' : '6px')};
  border-radius: 8px;
  background-color: ${(props) => {
    switch (props.$technologyType) {
      case 'frontend':
        return '#E3F2FD'; // Light blue
      case 'backend':
        return '#F3E5F5'; // Light purple
      case 'fullstack':
        return '#E8F5E8'; // Light green
      case 'mobile':
        return '#FFF3E0'; // Light orange
      default:
        return '#F5F5F5'; // Light gray
    }
  }};
  color: ${(props) => {
    switch (props.$technologyType) {
      case 'frontend':
        return '#1976D2'; // Dark blue
      case 'backend':
        return '#7B1FA2'; // Dark purple
      case 'fullstack':
        return '#388E3C'; // Dark green
      case 'mobile':
        return '#F57C00'; // Dark orange
      default:
        return '#424242'; // Dark gray
    }
  }};
  border: 1px solid
    ${(props) => {
      switch (props.$technologyType) {
        case 'frontend':
          return '#BBDEFB'; // Lighter blue
        case 'backend':
          return '#E1BEE7'; // Lighter purple
        case 'fullstack':
          return '#C8E6C9'; // Lighter green
        case 'mobile':
          return '#FFE0B2'; // Lighter orange
        default:
          return '#E0E0E0'; // Lighter gray
      }
    }};
`;
